window.onload = function () {
  // v1
  if (BSS_B2B.formId && window.location.pathname === "/account/register") {
    const loop = setInterval(() => {
      const submitButton = document.querySelector("#create_customer_button");
      if (submitButton) {
        submitButton.innerText = "INVIA LA RICHIESTA";
        clearInterval(loop);
      }
    }, 100);

    setTimeout(() => {
      clearInterval(loop);
    }, 8000);
  }

  // v2
  if (window.location.pathname === "/account") {
    const loop = setInterval(() => {
      const buttonEdit = document.querySelector(`a[href="/pages/b2b-registrazione?edit=bss_b2b"]`);
      if (buttonEdit) {
        buttonEdit.innerText = "Modifica informazioni";
        buttonEdit.style.opacity = "1";
        clearInterval(loop);
      }
    }, 100);

    setTimeout(() => {
      clearInterval(loop);
    }, 8000);
  }
  if (window.location.pathname === "/pages/b2b-registrazione") {
    const loop = setInterval(() => {
      const submitButton = document.querySelector(
        ".bss-b2b-rf-submit-button input"
      );
      const url = new URL(location.href);
      if (submitButton) {
        if (url.search.includes("edit")) {
          submitButton.value = "SALVA";
        }else {
          submitButton.value = "INVIA LA RICHIESTA";
        }
        clearInterval(loop);
      }
    }, 100);

    setTimeout(() => {
      clearInterval(loop);
    }, 8000);
  }

  // edit text Enter DC in cart page
  if (window.location.pathname === "/cart") {
    const loop = setInterval(() => {
      const submitButtonDC = document.querySelector(
        "#bss-b2b-discount-code-submit span"
      );
      if (submitButtonDC) {
        submitButtonDC.value = "INVIA LA RICHIESTA";
        $("#bss-b2b-discount-code-input").attr(
          "placeholder",
          "Inserisci il codice sconto"
        );
        clearInterval(loop);
      }
    }, 100);

    setTimeout(() => {
      clearInterval(loop);
    }, 8000);

    const loop1 = setInterval(() => {
      const DCBox = $(".bss-b2b-discount-code-wrapper");
      if (DCBox) {
        $(".cart__footer-inner").before(DCBox);
        clearInterval(loop1);
      }
    }, 50);

    setTimeout(() => {
      clearInterval(loop1);
    }, 8000);
  }
};

setTimeout(() => {
  const btnCheckoutQuickCart = document.querySelector(
    ".quick-cart__footer-inner .quick-cart__submit"
  );
  if (btnCheckoutQuickCart) {
    btnCheckoutQuickCart.style.pointerEvents = "unset";
    btnCheckoutQuickCart.style.opacity = 1;
  }
  const btnCheckoutMainCart = document.querySelector(
    ".cart__footer-inner .cart__submit"
  );
  if (btnCheckoutMainCart) {
    btnCheckoutMainCart.style.pointerEvents = "unset";
    btnCheckoutMainCart.style.opacity = 1;
  }
  // const btnAddToCart = document.querySelector('.product-form__cart-submit')
  // if (btnAddToCart) {
  //     $(btnAddToCart).on("click", function() {
  //         setTimeout(() => {
  //             const btnCheckoutPopupCart = document.querySelector(".purchase-confirmation-popup__submit");
  //             BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData);
  //             if (btnCheckoutPopupCart) {
  //                 let loop = setInterval(() => {
  //                     const areaCheckoutPopupCart = document.querySelector(".animation--purchase-confirmation-footer-item");
  //                     if (areaCheckoutPopupCart) {
  //                         clearInterval(loop);
  //                         console.log(areaCheckoutPopupCart)
  //                         $(areaCheckoutPopupCart).on("click dblclick", function(e) {
  //                           console.log("dblclick")
  //                             e.preventDefault();
  //                             e.stopImmediatePropagation();
  //                         });
  //                     }
  //                 }, 100)
  //               setTimeout(() => {
  //                 clearInterval(loop);
  //               }, 5000)
  //             }
  //         }, 500)
  //     })
  // }
}, 1500);

if (BSS_B2B && window.location.pathname === "/pages/b2b-registrazione") {
  document.addEventListener("BSS_get_form_success", (e) => {
    setTimeout(() => {
      const countryField = $(".bss-b2b-rf-field.field-country");
      if (countryField.length) {
        $("#country-list li[value='IT']").trigger("click")
      }
    }, 1000);
  });
}

if(typeof BSS_B2B != undefined) {
  if(window.location.pathname.includes("/account")) {
    let loop = setInterval(() =>{
      const title = document.querySelector('[bss-b2b-custom-info-field] h2');
      if (title) {
        clearInterval(loop);
        title.textContent = 'Dati di Fatturazione';
      }
    }, 200)
    setTimeout(() =>{
      clearInterval(loop);
    }, 10000)
    
  }
}
